module.exports = __webpack_public_path__ + "static/media/icon-box-2.d29041ae.svg";